import { createStore } from 'vuex'

export default createStore({
  state: {
    punchse: [
      {
        id: 1,
        artist: "Dinos",
        album: "",
        album_key: "mg",
        title: "Moja Ghost",
        quote: "J'rentre chez Gucci, la vendeuse me suit partout, elle croit qu'elle va devenir Georgina."
      },
      {
        id: 2,
        artist: "Dinos",
        album: "",
        album_key: "mg",
        title: "Moja Ghost",
        quote: "On pèche après la prière comme si on s'lavait les mains avec de l'eau sale."
      },
      {
        id: 3,
        artist: "Dinos",
        album: "",
        album_key: "mg",
        title: "Moja Ghost",
        quote: "Y a des blessures dont le cerveau n'se souvient pas."
      },
      {
        id: 4,
        artist: "Dinos",
        album: "",
        album_key: "mg",
        title: "Moja Ghost",
        quote: "Le daron m'a jamais dit qu'il m'aimait parce que son daron lui a jamais dit qu'il l'aimait."
      },
      {
        id: 5,
        artist: "Dinos",
        album: "",
        album_key: "mg",
        title: "Moja Ghost",
        quote: "On perd du temps à fermer nos cœurs au lieu d'nos bouches."
      },
      {
        id: 44,
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "AMG Performance",
        quote: "Il fait froid dans la vie d'une mère."
      },
      {
        id: 45,
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "AMG Performance",
        quote: "Toute l'année à l'hôtel comme si j'avais pas d'barraque."
      },
      {
        id: 7,
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "AMG Performance",
        quote: "Tu peux n'pas m'aimer mais tu ne peux pas m'détester."
      },
      {
        id: 8,
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "AMG Performance",
        quote: "J'ai constamment l'impression de perdre du temps."
      },
      {
        id: 9,
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "NMD_V3",
        quote: "Ma vie part en fumée comme si j'étais Snoop Dogg."
      },
      {
        id: 10,
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "NMD_V3",
        quote: "Je suis comme la mort, comme les problèmes, j'disparais, je réapparais."
      },
      {
        id: 11,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Iceberg Slim",
        quote: "J'n'ai que la glace dans l'cœur."
      },
      {
        id: 12,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Iceberg Slim",
        quote: "Loyer sur l'poignet, who the fuck is APL?"
      },
      {
        id: 13,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Iceberg Slim",
        quote: "J'sais pas j'rêve de combien, tout c'que j'sais c'est qu'j'sais pas comment écrire cette somme en chiffres romains."
      },
      {
        id: 14,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Iceberg Slim",
        quote: "Si tu m'cherches, allume ta télé."
      },
      {
        id: 15,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Argentique",
        quote: "J'suis sur terre pour l'oseille, pas rouler en clio."
      },
      {
        id: 16,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Argentique",
        quote: "J'ai l'inspi de Dorcel et celle de Tarantino."
      },
      {
        id: 17,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Argentique",
        quote: "J'suis mort avant de naître."
      },
      {
        id: 18,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Hiver 2004",
        quote: "J'ai de l'amour pour très peu de gens car il m'reste très peu de temps."
      },
      {
        id: 19,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Hiver 2004",
        quote: "Je suis le quartier pas la rue."
      },
      {
        id: 20,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Hiver 2004",
        quote: "...Beaucoup le disent, très peu le pensent."
      },
      {
        id: 21,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Hiver 2004",
        quote: "...Mais ça ira mieux demain, même si j'l'ai déja dit hier."
      },
      {
        id: 22,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Hiver 2004",
        quote: "Mon cœur brûle mais n'appelle pas les pompiers."
      },
      {
        id: 23,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Spleen",
        quote: "Cœur noir comme une salle de ciné."
      },
      {
        id: 24,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Spleen",
        quote: "Mais mon cœur reste neutre comme la Suisse, comme un PH 7."
      },
      {
        id: 25,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Rue sans nom",
        quote: "Je m'demande c'que les aveugles peuvent voir pendant leurs rêves."
      },
      {
        id: 26,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Rue sans nom",
        quote: "Maman nous répétait que la vraie richesse, c'est d'avoir quelque chose que l'argent ne peut pas acheter."
      },
      {
        id: 28,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Flashé",
        quote: "Meilleur sous tout les angles fuck un polygone."
      },
      {
        id: 29,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Flashé",
        quote: "Les profs de maths à Nazareth n'enseignent pas les produits en croix."
      },
      {
        id: 30,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Flashé",
        quote: "J'ai appelé l'bonheur mais j'crois qu'c'est un faux number."
      },
      {
        id: 31,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Flashé",
        quote: "On a peur de Dieu , t'as peur de perdre tes followers."
      },
      {
        id: 32,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Helsinki",
        quote: "Si tu savais comme je t'déteste tu sauras à quel point je t'aime."
      },
      {
        id: 33,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "J'agis comme si mes péchés resteront impunis."
      },
      {
        id: 34,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "La vie n'est qu'une partition sans quinte."
      },
      {
        id: 35,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "Hey, je crois au proverbe qui dit d'pas croire aux proverbes."
      },
      {
        id: 36,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "Ma morale est partie aussi vite que mon premier salaire."
      },
      {
        id: 37,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "C'est quoi l'plus lourd entre un kilo d'péchées et un kilo de bonnes actions?"
      },
      {
        id: 38,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Quelqu'un de mieux",
        quote: "Hier j'les critiquais, aujourd'hui j'leur ressemble."
      },
      {
        id: 39,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Bloody Mary",
        quote: "Bref , jsuis venu prendre c'qui m'revient pas sans même dire merci."
      },
      {
        id: 40,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Les pleurs du mal",
        quote: "Rien dans l'porte monnaie, on avait tout dans l'cœur."
      },
      {
        id: 41,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Les pleurs du mal",
        quote: "Mémoire dans la peau comme Jason Bourne."
      },
      {
        id: 42,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Les pleurs du mal",
        quote: "J'suis obscur, j'dors que d'un oeil comme Jean-Marie Le Pen."
      },
      {
        id: 43,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Magenta",
        quote: "Si la vie était un hôtel j'aurais encaisser mon chèque de caution."
      },
      {
        id: 27,
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Donne moi un peu de temps",
        quote: "Rien n'est plus hypocrite que le regret."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Notification",
        quote: "On a droit a une autre chance mais pas pour la même erreur."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Notification",
        quote: "Mais celui qui r'vient en premier n'est pas l'plus faible juste le plus mature."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sophistiqué",
        quote: "Fuck le dress code , j'suis toujour en noir."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sophistiqué",
        quote: "J'aimerais t'aimer mais mon cœur cassé est inutile comme ralentir après s'être fait flashé."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sophistiqué",
        quote: "Mais gros, j'suis pas un briquet j'suis le feu. Négro, j'suis pas un joueur, j'suis le jeu."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sophistiqué",
        quote: "J'pars en avance et j'arrive en retard comme Imany."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sophistiqué",
        quote: "Je meurs le jour, je vis la nuit."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Presque célèbre",
        quote: "Ils ne m'aiment pas, je les déteste tellement."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Presque célèbre",
        quote: "On dit aussi que, parfois pour punnir les hommes, Dieu leur donne ce qu'ils veulent. Et j'pense qu'il m'a rendu service en me donnant ce que je voulais pas."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Placebo",
        quote: "Rien de très cartésien, ma tristesse part et vient."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Placebo",
        quote: "Je me racine carré de 10 000 pas très bien."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Placebo",
        quote: "J'connais pas grande chose en amour mais j'sais que j'taime."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Coco",
        quote: "L'argent fait l'bonheur j'crois."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Coco",
        quote: "L'bonheur dépend de toi car être heureux est un choix."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "PFW",
        quote: "Mes actes ne vont pas trop avec mes prières."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "PFW",
        quote: "Sans musique, j'suis comme sans moelle épinière."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "PFW",
        quote: "J'veux pas d'amis, j'veux du bif."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Fetty Wap",
        quote: "Si tu portes l'oeil, j'te Fetty Wap."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Fetty Wap",
        quote: "Tu crois pas en Dieu, pourquoi tu chantes \"God's Plan\"?"
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Rétrograde",
        quote: "Peut-être qu'ils ont raison, l'argent ne rend pas heureux."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Rétrograde",
        quote: "Exister c'n'est pas vivre."
      },
      {
        artist: "Dinos",
        album: "Imany(Deluxe)",
        album_key: "imany",
        title: "Sinéquanone",
        quote: "Le premier des perdants n'est rien d'autre que le deuxième."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "AMARU",
        quote: "Tous mes gars se marient, tous mes gars font des gosses, moi je regarde leur stories."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "AMARU",
        quote: "Celui qui a écrit mon destin s'est pas réveillé du bon pied."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "AMARU",
        quote: "Parfois le brolique fait moins mal qu'les mots."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "AMARU",
        quote: "Je suis Tupac AMARU, je joue pas à l'amour."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "AMARU",
        quote: "J'suis pas fait pour être en couple j'suis fait pour être en distrib'."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "SP98",
        quote: "Elle me parle de confiance, elle sait pas que j'suis paro d'mon propre bigo."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "SP98",
        quote: "La proximité engendre le mépris."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "SP98",
        quote: "J'suis instable, j'suis l'reflet d'mon époque."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "Enfant du siècle",
        quote: "J'suis dans ma galaxie, même le xanax ne m'fait plus d'effet."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "Enfant du siècle",
        quote: "Leurs Je t'aime sont faux comme leurs sacs Hermès."
      },
      {
        artist: "Dinos",
        album: "Sea Dweller",
        album_key: "sd",
        title: "Enfant du siècle",
        quote: "Khamsa fi 3ainyk."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Chrome Hearts",
        quote: "J'suis bipolaire comme la guerre froide ou l'fils de Donda(West)."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Portes Suicide",
        quote: "C'est la dernière fois qu'j'me dis que c'est la dernière fois."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Portes Suicide",
        quote: "Tout les lundis, j'pars en week-end."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Pichichi Anderson",
        quote: "Pour faire du seille-o faut du seille-o. Pour faire des euros faut des euros."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Pichichi Anderson",
        quote: "J'regarde jamais la météo, quand tu as du biff, il fait toujours beau."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Pichichi Anderson",
        quote: "Y a des gens qui ont des pères, y a des gens qui ont des géniteurs."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Quatres Saisons",
        quote: "Y a sûrement quelqu'un qu'tu connais qui pleure pendant que tu ris."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Quatres Saisons",
        quote: "Quand j'règle un problème, j'en aggrave un autre."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Quatres Saisons",
        quote: "Pourquoi les gens pensent te connaître avec deux-trois questions? Pourquoi les gens qu'tu aimes sont pas toujours les gens qu'tu crois qu'ils sont?"
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Simyaci",
        quote: "Enlève les erreurs, remets le temps.\nEnlève la pluie, remets le vent.\nEnlève la forme, remets le sens.\nEnlève la piano, remets le sample."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Simyaci",
        quote: "L'amour dépasse le risque, la vie réelle dépasse les rêves."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Simyaci",
        quote: "Mon coeur s'effrite comme du polystyrène."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "L'Univer Ne Nous Voit Pas Danser",
        quote: "Même les psychologues ont des psychologues."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Rue de Sèvres",
        quote: "Ne m'demande pas ce que je deviens, moi même non plus je ne sais pas."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Rue de Sèvres",
        quote: "Chuis dos au mur comme un tableau, j-me dirige vers la vie de Pablo Escobar-Picasso."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "CRTL + V",
        quote: "Il y a les gens qu'on voit et les gens qu'on remarque. Les gens qu'on remarque font tout pour pas qu'on les voit."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "CRTL + V",
        quote: "Tu sais l'amour c'est pas une application."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "CRTL + V",
        quote: "Avant t'affrontais les choses, maintenant tu t'échappes. Avant tu vivais les choses, maintenant tu les snap."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Rouge Drama",
        quote: "On est pas obligés d'être amoureux pour s'aimer."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Rouge Drama",
        quote: "Le temps répare mais regarde autour de nous comment les gens s'séparent."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Par Amour",
        quote: "Tu parles avec les yeux, comme les gens heureux. J'parle avec le feu, comme les gens anxieux."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Par Amour",
        quote: "Je m'entraine à être heureux, pour être prêt le jour où le bonheur sera vraiment là."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Solitaire 1895",
        quote: "Et si les gens sans amours étaient odieux et si les gens amoureux étaient idiots."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Solitaire 1895",
        quote: "Quand le bonheur te pointe du doigt, la souffrance le suis du regard."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Future Nostalgia",
        quote: "Mes souvenirs sont indécodables, mon coeur est comme l'Arizona. Mes pensées sont pas raisonnables."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "ADN",
        quote: "Si monotone, les racistes disent qu'ils sont pas racistes, et c'est pareil pour les homophobes."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "ADN",
        quote: "La mort, c'est une chanson sans partition. La vie, c'est un film sans partie deux donc vis juste et ferme les yeux."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Aquarius",
        quote: "Mon taux d'amour est plafonné."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Aquarius",
        quote: "J'regrette pas c'que j'ai fait, j'regrette c'que j'ai pas fait."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Aquarius",
        quote: "J'veux revenir au début, appuyer sur \"Reset\". Annuler les problèmes, appuyer sur Pomme, Z."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Aquarius",
        quote: "J'suis débiteur de sommeil, j'suis créditeur de problèmes."
      },
      {
        artist: "Dinos",
        album: "Hiver à Paris",
        album_key: "hap",
        title: "Triste Anniversaire",
        quote: "J'suis triste le jour d'mon anniversaire."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Hamsterdam",
        quote: "J'suis là car la faucheuse m'a ratée."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Deïdo",
        quote: "J'ai changé bien trop tard, je sais, j'aurais dû l'faire avant. Maintenant j'essaye de soigner une tumeur avec d'l'Effleralgan."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Deïdo",
        quote: "Deux-mille euros l'cercueil, même la mort, ça coûte cher."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Deïdo",
        quote: "J'vais niquer ta mère même dans l'métaverse."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Deïdo",
        quote: "J'réfléchis comme un miroir cassé."
      },
      {
        artist: "Dinos",
        album: "Aquanaute",
        album_key: "aquanaute",
        title: "Deïdo",
        quote: "Photo d'groupe on rigole tous mais parmi nous, y a quelqu'un qui souffre."
      },
      {
        artist: "Dinos",
        album: "NAUTILUS",
        album_key: "nautilus",
        title: "Prozac",
        quote: "Même seul, j'suis mal accompagné."
      },
      {
        artist: "Dinos",
        album: "NAUTILUS",
        album_key: "nautilus",
        title: "Equilibre",
        quote: "Le pardon c'est la meilleure des vengances mais j'aime pas mangé froid."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "On meurt bientôt",
        quote: "J'suis à terre mais j'suis pas tombé."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "XNXX",
        quote: "J'ai des trous de mémoire, qu'est-c'que ça fait d'aimer quelqu'un? Je n'm'en souviens pas."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "XNXX",
        quote: "Comment aimer un coeur en acier valyrien?"
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "OMRI",
        quote: "Je viens d'là où tout le monde parle de s'en sortir mais personne veut que tu t'en sortes."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "N'Tiekar",
        quote: "Au paradis, y a plus de place, il en reste en enfer."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "N'Tiekar",
        quote: "Tout baiser, c'est le plan A, tout baiser, c'est le plan B."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "N'Tiekar",
        quote: "Renoi, tu pourras pas savourer la victoire comme il se doit si tu connais pas la défaite."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "N'Tiekar",
        quote: "J'agis comme si j'n'avais plus de cerveau, même quand j'ai raison j'agis comme si j'avais tort."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Oskur",
        quote: "J'avoue, pour aimer quelqu'un comme moi, il faut être fou."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Oskur",
        quote: "J'ai besoin d'aide, ouais, j'ai besoin d'L.O.V.E."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Oskur",
        quote: "Mes absences font du vide, mes silences font du bruit."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Oskur",
        quote: "J'mendormirai quand j's'rai riche."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "No Love",
        quote: "Je n'trouverai pas la bonne personne tant que je n'serai pas la bonne personne."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "No Love",
        quote: "Aucune attache, aucune pression, les réponses sont dans les questions."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Wouuh",
        quote: "J'suis dangereux avec les feu-meu depuis l'époque des feuilles Diddl."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Wouuh",
        quote: "Si t'oublies son prénom, emmène-la au Starbucks."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Franck Ocean",
        quote: "Ils m'ont pas vu monter mais j'les ai vu descendre."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Adeola interlude",
        quote: "Ne m'parlez pas de vous, ne m'parlez pas d'amour. Ne me parlez pas tout court, j'suis pas vraiment dans le mood."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Mack le Bizz Freestyle",
        quote: "On r'fait pas l'monde avec des si mais avec du biff."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Mack le Bizz Freestyle",
        quote: "J'viens d'là où les anges gardiens sont paresseux. J'viens d'là où les daronnes sont pas heureuses."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Mack le Bizz Freestyle",
        quote: "Y'en a toujours un qu'est plus amoureux qu'l'autre."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Mack le Bizz Freestyle",
        quote: "J'sais qu'Dieu existe mais j'sais pas pourquoi . J'sais qu'l'amour existe mais pas pour moi."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Arob@se",
        quote: "Mon plus gros mensonge c'est quand j'dis que ça ira."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Quand les cailleras prient",
        quote: "Chez nous, je t'aime c'est beaucoup trop dur à dire."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Quand les cailleras prient",
        quote: "Il m'a fallu des chaînes en or pour me rendre compte que j'suis esclave du temps."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Quand les cailleras prient",
        quote: "J'aime pas les gens heureux parce qu'ils m'rappellent qu'en c'moment, moi, j'l'suis pas trop."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Les garçons ne pleurent pas",
        quote: "Souvent, je vois mais je n'regarde pas, souvent j'entends mais je n'écoute pas. Même quand je saigne mes larmes ne coulent pas."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Les garçons ne pleurent pas",
        quote: "Les garçons ne pleurent pas, maintenant j'suis un homme alors je pleure."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Taciturne",
        quote: "Les gens bien finissent mal, les gens mauvais finissent mal aussi."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Taciturne",
        quote: "Tout c'qui est bon est illégal, alors j'commence à croire que si l'amour c'était si bien, ça s'rait interdit par la loi."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Au revoir",
        quote: "J'suis parti sans dire \"au r'voir\", je reviendrai sûrement sans dire \"bonjour\"."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Ecoute, ça fait un bail qu'on rappe mais ça paye juste maintenant parc'qu'on a sucé la bite de personne donc ça met plus de temps."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Dis-moi c'que j'dois entendre, me dis pas c'que j'veux entendre."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Tellement d'fils de putes qu'ont des mères irréprochables."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Maintenant, j'refuse des feats à des gens qui m'refusaient des feats."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Souhaite-nous la santé et l'argent, tout l'reste, on n'y a jamais cru, tout le reste, on l'a jamais vu."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "S'tu vois un une Datejust 41, dis lui qu'j'ai envie d'la serrer."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Booska taciturne",
        quote: "Dieu m'a mis dans des eaux troubles, pas pour m'noyer mais pour m'nettoyer."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Les pleurs du mâle",
        quote: "Y'a c'qu'on veut et c'qui est bien pour nous. On s'en rend compte que c'qu'on veut est mal pour nous, quand c'qui est bien pour n'est plus à nous."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Les pleurs du mâle",
        quote: "J'broie du noir comme une machine à café."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Sagittaire",
        quote: "J'baise les féministes d'internet j'sais comment on traite une femme."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Sagittaire",
        quote: "Chez nous, on s'aime mais on s'aide pas."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Slide",
        quote: "J'ouvre toujours les yeux quand il est trop tard."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Slide",
        quote: "Moi, ma thérapie s'fait sur des accords."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Slide",
        quote: "Je n'sais pas dire: \"je t'aime\", je sais le montrer."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Slide",
        quote: "J'fais ni d'mal ni d'bien, mon Dieu, juste un peu des deux."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Slide",
        quote: "J'prie plus par peur que par sincérité."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Coeurjacking",
        quote: "On dit rarement tout ce qu'on pense parce qu'on sait pas l'faire."
      },
      {
        artist: "Dinos",
        album: "Taciturne",
        album_key: "taciturne",
        title: "Coeurjacking",
        quote: "Ils me dissent que plus c'est moins, ils me disent que moins c'est plus."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Diptyque",
        quote: "J'ai pas la conscience tranquille mais j'ai les poches pleines."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Diptyque",
        quote: "Aucun miracle, j'veux pas entendre la voie d'la raison parce que j'sais déjà que j'ferais l'inverse de c'qu'elle m'dira."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Diptyque",
        quote: "Soit les cieux sont très nocifs, soit mes vœux sont inaudibles, soit mon ange a une otite."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Diptyque",
        quote: "J'fais d'l'ASMR avec les bruits d'la machine à billets."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Diptyque",
        quote: "C'est pas l'argent qui fait l'homme, c'est l'respect. Mais ici on respecte que les gens riches, alors vide la caisse."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "5711",
        quote: "Ça paye pas trop de vivre ici, ça paye pas trop d'être lyriciste."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "5711",
        quote: "J'fais pas toujours le bien mais j'suis pas mauvais. On n'était pas pauvres, on était fauchés."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "5711",
        quote: "J'vais faire buguer l'Apollo Twin."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "5711",
        quote: "Plus de naissances que de décès, mais plus de mort que de vie, car on peut mourir sans avoir rien vécu."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "FMR",
        quote: "Je sais qu'j'te manque mais si j't'appelle après minuit bébé, s'te plaît, ne réponds pas."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "FMR",
        quote: "Vivre ma vie, c'est conduire un Urus sans assurance."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Moins un",
        quote: "J'ai l'sommeil léger depuis qu'j'ai compris que ma mort sera plus longue que ma vie."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Moins un",
        quote: "J'suis l'fantôme de Sankara dans l'cul d'Marine Le Pen."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Du mal à te dire",
        quote: "Y a pas d'étrangers, y a juste des gens qui s'connaissent pas, Et des gens qui s'connaissent qui sont comme des étrangers."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Du mal à te dire",
        quote: "J'm'en vais pour mieux revenir comme le fils de Marie."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Du mal à te dire",
        quote: "Les ignorants sont plus heureux que les savants."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Du mal à te dire",
        quote: "Si t'as les mauvaises réponses, c'est que t'as les mauvaises question."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "El Pichichi",
        quote: "Le mariage, ça coûte cher, le divorce encore plus."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Tulum",
        quote: "Avec des si on refait le monde, on refait toute la planète."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Prends soin de toi",
        quote: "Déçu d'la vie comme une femme enceinte d'un viol."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Prends soin de toi",
        quote: "Si tu connais pas toute ta famille, c'est que t'es encore pauvre."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Snitch",
        quote: "Ils nous regardaient d'haut mais aujourd'hui, ils peuvent même plus nous voir."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Je wanda",
        quote: "Le bonheur c'est pas quand on peut, non, c'est quand on veut."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Césaire",
        quote: "J'joue à la roulette russe, avec le chargeur plein."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Césaire",
        quote: "Maman veut des loves mais elle dit que l'argent n'fait pas tout, certains millionnaires sont pauvres."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Césaire",
        quote: "Les perdants ont des excuses, les vainqueurs ont des raisons."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Demain n'existe plus",
        quote: "Elle m'a dit qu'elle m'aime, j'lui ai dit qu'ça lui passera."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Demain n'existe plus",
        quote: "L'amour devrait être remboursé par la Sécurité Sociale."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Le nord se souvient",
        quote: "J'suis pas allergique au pollen, j'suis allergique à la hess."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Futur Ex",
        quote: "Elle m'a dit qu'elle m'aimait, j'ai répondu, \"Ah bon?\"."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Futur Ex",
        quote: "Ils ont lu deux trois articles sur le Bitcoin. Maintenant, ils s'prennent pour des traders."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Futur Ex",
        quote: "Tu l'as vu en regardant la télé, J'l'ai vu en regardant la fenêtre."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Walther PP",
        quote: "J'sors du sche-Por on dirait que t'as vu la vierge."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Walther PP",
        quote: "J'porte que du ro-ro, si j'veux j'porte mes albums."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Surcôté",
        quote: "Les ennemis d'mes amis sont pas mes ennemis parce que j'ai compris qu'la plupart d'mes amis deviendront mes ennemis."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Surcôté",
        quote: "J'suis heureux mais j'étais pas triste avant. J'sais plus à qui envoyer les Tweets marrants."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Madone",
        quote: "J'ai parlé de toi avec ma daronne, je t'ai confondu avec la Madone."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "93 mesure",
        quote: "Chaque contrôle de police me rapproche de mon feat avec 2Pac."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "93 mesure",
        quote: "J'deviens fou, j'vois des gens heureux partout, soit l'amour c'est pas pour moi, soit j'suis pas fait pour l'amour."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "93 mesure",
        quote: "Avant, j'croyais qu'j'priais puis, j'ai grandi et j'ai compris que tout c'que j'fais, c'est récité des phrases que j'ai appris par cœur."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "93 mesure",
        quote: "Le bonheur est dans les choses simples."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Memento interlude",
        quote: "J'suis nostalgique des choses qu'on a jamais vécues."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Memento interlude",
        quote: "J'suis la solution et j'suis le problème."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Memento interlude",
        quote: "Si on attend rien de l'autre, on sera jamais déçu."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Memento interlude",
        quote: "Quand quelqu'un casse avec toi, dans sa tête il a déjà cassé depuis longtemps."
      },
      {
        artist: "Dinos",
        album: "Stamina, Memento",
        album_key: "sm",
        title: "Memento interlude",
        quote: "Me soigner, c'est mettre un pansement sur une prothèse."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "Solaar pleure encore",
        quote: "L'amour c'est tout c'qu'on avait, la mort, c'est plus long que la vie."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "Solaar pleure encore",
        quote: "On peut pleurer sans arrêter d'rire, on peut mourir sans arrêter d'vivre."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "J'suis insomniaque, mon seul rêve c'est d'pouvoir rêver."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "L'impression que j'me répète tu sais, mais l'humain est une erreur, c'est pour ça que l'erreur est humaine."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Si tu poses des bombes pour Dieu, j'préfère pas savoir c'que tu peux poser pour Satan."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Suffit qu'Instagram disparaisse pour que tout le monde t'oublie."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Certains disent que la vie coûte cher, et moi j'dis qu'elle n'a pas de prix."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Toutes les montres donnent la même heure, je m'en bats les couilles, j'veux une Audemars."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "J'aime la Police... Comic sans MS."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Si tu cherches un coup de foudre, prend une douche avec Pikachu."
      },
      {
        artist: "Dinos",
        album: "",
        album_key: "o",
        title: "",
        quote: "Dur de faire des projets carrés lorsque t'as pas un rond."
      }
    ],
    
    images: [
      {
        name: "Mojal Ghost",
        img: require('../assets/cover/o.jpg')
      },
      {
        name: "Taciturne",
        img: require('../assets/cover/taciturne.jpg')
      },
      {
        name: "Stamina",
        img: require('../assets/cover/sm.jpg')
      },
      {
        name: "Imany",
        img: require('../assets/cover/imany.jpg')
      },
      {
        name: "HAP",
        img: require('../assets/cover/hap.jpg')
      },
      {
        name: "Aquanaute",
        img: require('../assets/cover/aquanaute.jpg')
      },
      {
        name: "Nautilus",
        img: require('../assets/cover/nautilus.jpg')
      },
      {
        name: "SD",
        img: require('../assets/cover/sd.jpg')
      },
      {
        name: "others",
        img: require('../assets/cover/o.jpg')
      }
    ],
    images_flou: [
      {
        name: "Mojal Ghost",
        img: require('../assets/cover/flou/o.jpg')
      },
      {
        name: "Taciturne",
        img: require('../assets/cover/flou/taciturne.jpg')
      },
      {
        name: "Stamina",
        img: require('../assets/cover/flou/sm.jpg')
      },
      {
        name: "Imany",
        img: require('../assets/cover/flou/imany.jpg')
      },
      {
        name: "HAP",
        img: require('../assets/cover/flou/hap.jpg')
      },
      {
        name: "Aquanaute",
        img: require('../assets/cover/flou/aquanaute.jpg')
      },
      {
        name: "Nautilus",
        img: require('../assets/cover/flou/nautilus.jpg')
      },
      {
        name: "SD",
        img: require('../assets/cover/flou/sd.jpg')
      },
      {
        name: "others",
        img: require('../assets/cover/flou/o.jpg')
      }
    ],
  },
  getters: {
    punchse(state) {
      return state.punchse
    },
    imagesAlbums(state) {
      return state.images
    },
    imagesFlou(state) {
      return state.images_flou
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
